// AUTO-GENERATED by tools/sync-from-woo.mjs on 2026-09-16 — do not edit.
// Source of truth: Woo - Neckerchief Tool/scoutwise-necker-designer (class-swnd-data.php + assets/svg).
// 'n/a' = structural, not colourable. Key order is the UI order. stN keys match historical orders.
window.ScoutwiseSectionMaps = {
  "plain": {
    "st0": "Base"
  },
  "half-inch-border": {
    "st2": "Base",
    "st0": "1/2 Inch Border"
  },
  "1-inch-border": {
    "st1": "Base",
    "st0": "1 Inch Border"
  },
  "insert-hald-inch-border": {
    "st0": "Base",
    "st2": "1/2 Inch Inset Border"
  },
  "insert-double-half-in-border": {
    "st7": "Base",
    "st6": "Outer Border",
    "st1": "Inner Border",
    "st4": "n/a"
  },
  "double-inch-border": {
    "st6": "Base",
    "st7": "Outer Border",
    "st5": "Inner Border",
    "st0": "n/a",
    "st1": "n/a",
    "st2": "n/a",
    "st3": "n/a"
  },
  "double-inch-4-colour-border": {
    "st0": "Base",
    "st1": "Left Outer Border",
    "st5": "Left Inner Border",
    "st7": "Right Inner Border",
    "st8": "Right Outer Border",
    "st3": "n/a",
    "st4": "n/a",
    "st10": "n/a"
  },
  "1-inch-2-colour-border": {
    "st0": "Base",
    "st1": "Left Border",
    "st2": "Right Border",
    "st3": "n/a"
  },
  "half-and-half": {
    "st3": "Left Half",
    "st0": "Right Half",
    "st1": "n/a",
    "st2": "n/a"
  },
  "half-and-half-1-inch-border": {
    "st3": "Left Half",
    "st1": "Right Half",
    "st2": "1 Inch Border",
    "st0": "n/a"
  },
  "half-and-half-1-inch-2-colour-border": {
    "st6": "Left Half",
    "st1": "Right Half",
    "st4": "Left Border",
    "st2": "Right Border",
    "st0": "n/a",
    "st3": "n/a",
    "st5": "n/a"
  },
  "half-and-half-double-half-inch-four-colour-border": {
    "st7": "Left Half",
    "st13": "Right Half",
    "st12": "Left Inner Border",
    "st10": "Left Outer Border",
    "st6": "Right Inner Border",
    "st9": "Right Outer Border",
    "st0": "n/a",
    "st1": "n/a",
    "st2": "n/a",
    "st3": "n/a",
    "st4": "n/a",
    "st5": "n/a",
    "st8": "n/a",
    "st11": "n/a"
  },
  "1-inch-center-stripe": {
    "st3": "Left Half",
    "st2": "Right Half",
    "st4": "Centre Stripe",
    "st0": "n/a",
    "st1": "n/a"
  },
  "double-1-inch-4-colour-border": {
    "st0": "Base",
    "st1": "Left Inner Border",
    "st2": "Left Outer Border",
    "st3": "Right Inner Border",
    "st4": "Right Outer Border",
    "st5": "n/a"
  },
  "double-1-inch-border": {
    "st0": "Base",
    "st1": "Outer Border",
    "st3": "Inner Border",
    "st2": "n/a",
    "st4": "n/a"
  },
  "half-inch-2-colour-border": {
    "st2": "Base",
    "st0": "Left Border",
    "st1": "Right Border"
  },
  "half-and-half-with-half-inch-border": {
    "st2": "Left Half",
    "st3": "Right Half",
    "st5": "1/2 Inch Border",
    "st0": "n/a",
    "st1": "n/a"
  },
  "half-and-half-with-half-inch-2-colour-border": {
    "st6": "Left Half",
    "st4": "Right Half",
    "st1": "Left Border",
    "st2": "Right Border",
    "st0": "n/a",
    "st3": "n/a"
  },
  "half-and-half-w-double-inch-half-border-colour": {
    "st3": "Left Half",
    "st4": "Right Half",
    "st1": "Outer Border",
    "st5": "Inner Border",
    "st0": "n/a"
  },
  "triple-border-necker": {
    "st1": "Base",
    "st2": "Outer Border",
    "st3": "Middle Border",
    "st4": "Inner Border",
    "st0": "n/a"
  }
};

/** Human-readable section name for a template + CSS class; falls back to the class. */
window.ScoutwiseGetSectionName = function (templateSlug, cssClass) {
  const map = window.ScoutwiseSectionMaps[templateSlug] || {};
  return map[cssClass] || cssClass;
};
/** Colourable sections for a template, in UI order. Excludes 'n/a' structural elements. */
window.ScoutwiseGetTemplateSections = function (templateSlug) {
  const map = window.ScoutwiseSectionMaps[templateSlug] || {};
  return Object.entries(map).filter(([, n]) => n && n !== 'n/a').map(([cssClass, name]) => ({ cssClass, name }));
};
